import React from "react";
import Tools from "./tools/Tools";
import Display from "./display/Display";
import "./App.css";

const App = () => (
	<div className="app-container">
		<Display />
		<Tools />
	</div>
);

export default App;
